import React from "react";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaDesktop,
  FaRobot,
  FaTwitter,
  FaDiscord,
  FaUserShield,
  FaHeadset,
  FaPaintBrush,
  FaVideo,
  FaStar,
  FaFire,
  FaCrown,
  FaRocket,
  FaRegGem,
  FaRegLightbulb,
  FaRegClock
} from "react-icons/fa";

export const servicesData = {
  web: {
    id: "web",
    title: "Web Development",
    icon: <FaLaptopCode size={60} color="#4F46E5" />,
    iconBg: "linear-gradient(135deg, #4F46E5, #818CF8)",
    shortDesc: "Modern responsive websites & web applications",
    longDesc: "We create stunning, high-performance websites that drive business growth. Our web development process combines cutting-edge technology with creative design to deliver exceptional user experiences that convert visitors into customers.",
    features: [
      "Fully responsive design",
      "SEO optimized structure",
      "Fast loading performance",
      "Admin dashboard integration",
      "Modern UI / UX",
      "API Integration",
      "Database Design",
      "Security Implementation"
    ],
    process: [
      {
        step: "01",
        title: "Discovery & Planning",
        desc: "Understanding your business goals, target audience, and project requirements"
      },
      {
        step: "02",
        title: "Design & Prototyping",
        desc: "Creating intuitive and engaging user interfaces with interactive prototypes"
      },
      {
        step: "03",
        title: "Development",
        desc: "Building with modern frameworks like React, Node.js, and best practices"
      },
      {
        step: "04",
        title: "Testing & QA",
        desc: "Rigorous testing across all devices, browsers, and performance optimization"
      },
      {
        step: "05",
        title: "Deployment & Support",
        desc: "Launch and ongoing maintenance with 24/7 support"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "10+ Years Experience",
        desc: "Proven track record in web development"
      },
      {
        icon: <FaRegGem />,
        title: "Latest Technologies",
        desc: "React, Node.js, Next.js, and modern frameworks"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Creative Solutions",
        desc: "Innovative approaches to complex problems"
      },
      {
        icon: <FaRegClock />,
        title: "On-Time Delivery",
        desc: "We respect your deadlines and budget"
      }
    ],
    pricing: [
      {
        name: "Basic",
        price: "$499",
        period: "one-time",
        icon: <FaStar />,
        features: [
          "5-page responsive website",
          "Basic SEO setup",
          "Contact form integration",
          "Social media integration",
          "1 month support",
          "Mobile friendly design",
          "Google Maps integration"
        ],
        popular: false,
        hot: false,
        buttonText: "Get Started"
      },
      {
        name: "Professional",
        price: "$999",
        period: "one-time",
        icon: <FaFire />,
        features: [
          "10-page dynamic website",
          "Advanced SEO optimization",
          "CMS integration (WordPress/Strapi)",
          "E-commerce functionality",
          "3 months support",
          "Performance optimization",
          "Analytics integration",
          "Custom animations",
          "Blog/News section",
          "Newsletter integration"
        ],
        popular: true,
        hot: true,
        buttonText: "Most Popular",
        badge: "🔥 HOT PACKAGE"
      },
      {
        name: "Enterprise",
        price: "$1999+",
        period: "custom",
        icon: <FaCrown />,
        features: [
          "Custom web application",
          "Advanced database design",
          "API development",
          "User authentication system",
          "6 months premium support",
          "Custom features",
          "Dedicated project manager",
          "SLA guarantee",
          "Load balancing",
          "Advanced security",
          "Custom dashboard"
        ],
        popular: false,
        hot: false,
        buttonText: "Contact Sales"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need a Custom Solution?",
      description: "Have specific requirements? Get a personalized quote tailored to your exact needs.",
      features: [
        "Custom feature development",
        "Flexible payment terms",
        "Dedicated team",
        "Priority support"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Pages",
          values: [5, 10, "Unlimited"]
        },
        {
          label: "Support (months)",
          values: [1, 3, 6]
        },
        {
          label: "Custom Features",
          values: ["No", "Limited", "Yes"]
        },
        {
          label: "SEO Optimization",
          values: ["Basic", "Advanced", "Premium"]
        },
        {
          label: "E-commerce",
          values: ["No", "Yes", "Advanced"]
        }
      ]
    },
    faq: [
      {
        question: "How long does web development take?",
        answer: "Basic websites take 2-3 weeks, professional websites take 4-6 weeks, and enterprise solutions take 8-12 weeks depending on complexity."
      },
      {
        question: "Do you provide hosting?",
        answer: "Yes, we offer reliable hosting solutions with 99.9% uptime guarantee, starting from $15/month."
      },
      {
        question: "Can I update the website myself?",
        answer: "Absolutely! We provide an easy-to-use CMS that lets you update content without any technical knowledge."
      },
      {
        question: "What about mobile responsiveness?",
        answer: "All our websites are fully responsive and look great on all devices - desktops, tablets, and mobile phones."
      }
    ]
  },
  
  mobile: {
    id: "mobile",
    title: "Mobile App Development",
    icon: <FaMobileAlt size={60} color="#10B981" />,
    iconBg: "linear-gradient(135deg, #10B981, #34D399)",
    shortDesc: "Cross-platform mobile applications",
    longDesc: "We build powerful mobile apps that engage users and deliver results. From concept to launch, we ensure your app stands out in the app stores with beautiful design and smooth performance.",
    features: [
      "Android & iOS apps",
      "Cross-platform development",
      "API integration",
      "Push notifications",
      "App store deployment",
      "User authentication",
      "Real-time features",
      "Offline support"
    ],
    process: [
      {
        step: "01",
        title: "Market Research",
        desc: "Analyzing market trends and competitor apps"
      },
      {
        step: "02",
        title: "UI/UX Design",
        desc: "Creating intuitive and engaging mobile interfaces"
      },
      {
        step: "03",
        title: "Development",
        desc: "Building with React Native/Flutter for cross-platform"
      },
      {
        step: "04",
        title: "Testing",
        desc: "Rigorous testing on multiple devices"
      },
      {
        step: "05",
        title: "App Store Launch",
        desc: "Submission and optimization for stores"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Native Performance",
        desc: "Apps that feel native on both platforms"
      },
      {
        icon: <FaRegGem />,
        title: "Beautiful UI/UX",
        desc: "Award-winning design team"
      },
      {
        icon: <FaRegLightbulb />,
        title: "App Store Optimization",
        desc: "Higher visibility and downloads"
      },
      {
        icon: <FaRegClock />,
        title: "Fast Development",
        desc: "Quick turnaround with quality"
      }
    ],
    pricing: [
      {
        name: "Basic App",
        price: "$999",
        period: "one-time",
        icon: <FaStar />,
        features: [
          "Single platform (Android/iOS)",
          "Up to 5 screens",
          "Basic features",
          "Standard design",
          "2 months support",
          "App store submission",
          "Basic analytics"
        ],
        popular: false,
        hot: false,
        buttonText: "Get Started"
      },
      {
        name: "Professional",
        price: "$2499",
        period: "one-time",
        icon: <FaFire />,
        features: [
          "Cross-platform (Both stores)",
          "Up to 15 screens",
          "Advanced features",
          "Custom UI/UX design",
          "API integration",
          "3 months support",
          "App store submission",
          "Push notifications",
          "Social media login",
          "Analytics dashboard"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Choice",
        badge: "⭐ BEST SELLER"
      },
      {
        name: "Enterprise",
        price: "$4999+",
        period: "custom",
        icon: <FaCrown />,
        features: [
          "Complex app with backend",
          "Unlimited screens",
          "Real-time features",
          "Custom animations",
          "6 months premium support",
          "Server infrastructure",
          "Dedicated team",
          "Advanced security",
          "Scalable architecture",
          "Admin panel"
        ],
        popular: false,
        hot: false,
        buttonText: "Contact Sales"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Complex App Idea?",
      description: "Have a unique app concept? Let's discuss your requirements for a custom quote.",
      features: [
        "Custom feature set",
        "Scalable architecture",
        "Dedicated development team",
        "Long-term support"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Platforms",
          values: ["Single", "Both", "Both + Backend"]
        },
        {
          label: "Screens",
          values: [5, 15, "Unlimited"]
        },
        {
          label: "Support",
          values: ["2 months", "3 months", "6 months"]
        },
        {
          label: "Custom Design",
          values: ["Standard", "Custom", "Premium"]
        }
      ]
    },
    faq: [
      {
        question: "How long does app development take?",
        answer: "Basic apps take 4-6 weeks, professional apps take 8-12 weeks, and enterprise apps take 3-4 months."
      },
      {
        question: "Do you help with app store submission?",
        answer: "Yes, we handle the entire app store submission process and ensure your app meets all guidelines."
      },
      {
        question: "Can you update my existing app?",
        answer: "Absolutely! We can work with your existing codebase or rebuild your app with modern technology."
      }
    ]
  },

  desktop: {
    id: "desktop",
    title: "Desktop Application",
    icon: <FaDesktop size={60} color="#F59E0B" />,
    iconBg: "linear-gradient(135deg, #F59E0B, #FBBF24)",
    shortDesc: "Powerful desktop software for all platforms",
    longDesc: "Professional desktop applications for Windows, Mac, and Linux. We build high-performance software with intuitive interfaces that streamline your business operations.",
    features: [
      "Windows software",
      "Mac applications",
      "Linux compatibility",
      "Offline functionality",
      "Database integration",
      "Fast performance",
      "User friendly interface",
      "Regular updates"
    ],
    process: [
      {
        step: "01",
        title: "Requirements Analysis",
        desc: "Understanding your business workflows"
      },
      {
        step: "02",
        title: "Architecture Design",
        desc: "Scalable and efficient software architecture"
      },
      {
        step: "03",
        title: "Development",
        desc: "Using C++, Python, or Electron for cross-platform"
      },
      {
        step: "04",
        title: "Testing",
        desc: "Compatibility testing across OS versions"
      },
      {
        step: "05",
        title: "Deployment",
        desc: "Installers and updates management"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "High Performance",
        desc: "Optimized for speed and efficiency"
      },
      {
        icon: <FaRegGem />,
        title: "Cross-Platform",
        desc: "Works on Windows, Mac, and Linux"
      },
      {
        icon: <FaRegLightbulb />,
        title: "User-Friendly",
        desc: "Intuitive interfaces for all users"
      },
      {
        icon: <FaRegClock />,
        title: "Reliable",
        desc: "Stable and bug-free applications"
      }
    ],
    pricing: [
      {
        name: "Basic Desktop App",
        price: "$799",
        period: "one-time",
        icon: <FaStar />,
        features: [
          "Single platform",
          "Basic functionality",
          "Local database",
          "Standard UI",
          "2 months support",
          "Basic reporting"
        ],
        popular: false,
        hot: false,
        buttonText: "Get Started"
      },
      {
        name: "Professional",
        price: "$1499",
        period: "one-time",
        icon: <FaFire />,
        features: [
          "Cross-platform support",
          "Advanced features",
          "Cloud sync",
          "Custom UI design",
          "API integration",
          "3 months support",
          "User management",
          "Advanced reporting",
          "Auto-updates"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Choice",
        badge: "🔥 HOT PACKAGE"
      },
      {
        name: "Enterprise",
        price: "$2999+",
        period: "custom",
        icon: <FaCrown />,
        features: [
          "All platforms",
          "Custom architecture",
          "Network features",
          "Advanced security",
          "6 months support",
          "Multi-user system",
          "Dedicated support",
          "Custom integrations",
          "Source code included"
        ],
        popular: false,
        hot: false,
        buttonText: "Contact Sales"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Software?",
      description: "Get a tailored desktop application built specifically for your business needs.",
      features: [
        "Custom functionality",
        "Legacy system integration",
        "Dedicated support team",
        "Flexible licensing"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Platforms",
          values: ["Single", "Cross-platform", "All + Network"]
        },
        {
          label: "Database",
          values: ["Local", "Local + Cloud", "Advanced"]
        },
        {
          label: "Support",
          values: ["2 months", "3 months", "6 months"]
        },
        {
          label: "Custom Features",
          values: ["No", "Limited", "Yes"]
        }
      ]
    },
    faq: [
      {
        question: "Can you migrate my existing software?",
        answer: "Yes, we can modernize and migrate your existing desktop applications to newer technologies."
      },
      {
        question: "Do you provide installation support?",
        answer: "Absolutely! We help with deployment and provide installation guides for your users."
      }
    ]
  },

  automation: {
    id: "automation",
    title: "Automation",
    icon: <FaRobot size={60} color="#EC4899" />,
    iconBg: "linear-gradient(135deg, #EC4899, #F472B6)",
    shortDesc: "Business automation & workflow optimization",
    longDesc: "Streamline your business processes with custom automation solutions. Save time and reduce errors with intelligent bots and workflow automation tools.",
    features: [
      "Automation scripts",
      "Bot development",
      "Data scraping",
      "Workflow automation",
      "Custom automation tools",
      "Schedule automation",
      "Email automation",
      "Report generation"
    ],
    process: [
      {
        step: "01",
        title: "Process Analysis",
        desc: "Identifying tasks to automate"
      },
      {
        step: "02",
        title: "Solution Design",
        desc: "Designing efficient automation workflow"
      },
      {
        step: "03",
        title: "Development",
        desc: "Building robust automation scripts"
      },
      {
        step: "04",
        title: "Testing",
        desc: "Ensuring reliability and accuracy"
      },
      {
        step: "05",
        title: "Deployment",
        desc: "Integrating with your systems"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Time Saving",
        desc: "Reduce manual work by 80%"
      },
      {
        icon: <FaRegGem />,
        title: "Error Reduction",
        desc: "Minimize human errors"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Scalable",
        desc: "Grows with your business"
      },
      {
        icon: <FaRegClock />,
        title: "24/7 Operation",
        desc: "Works around the clock"
      }
    ],
    pricing: [
      {
        name: "Basic Automation",
        price: "$299",
        period: "one-time",
        icon: <FaStar />,
        features: [
          "Single task automation",
          "Basic scripts",
          "Local execution",
          "Simple scheduling",
          "1 month support",
          "Basic reporting"
        ],
        popular: false,
        hot: false,
        buttonText: "Get Started"
      },
      {
        name: "Professional",
        price: "$599",
        period: "one-time",
        icon: <FaFire />,
        features: [
          "Multi-task automation",
          "Advanced scripts",
          "Cloud execution",
          "Complex scheduling",
          "3 months support",
          "Error handling",
          "Email notifications",
          "Data export",
          "API integration"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Choice",
        badge: "⭐ BEST VALUE"
      },
      {
        name: "Enterprise",
        price: "$1299+",
        period: "custom",
        icon: <FaCrown />,
        features: [
          "Full workflow automation",
          "Custom bot development",
          "Multiple integrations",
          "Real-time monitoring",
          "6 months support",
          "Scalable architecture",
          "Priority support",
          "Custom features",
          "Training included"
        ],
        popular: false,
        hot: false,
        buttonText: "Contact Sales"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Complex Automation Needs?",
      description: "Tell us about your automation requirements for a custom solution.",
      features: [
        "Custom workflow design",
        "Integration with existing systems",
        "Ongoing maintenance",
        "Training for your team"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Tasks",
          values: ["Single", "Multi-task", "Full workflow"]
        },
        {
          label: "Execution",
          values: ["Local", "Cloud", "Hybrid"]
        },
        {
          label: "Support",
          values: ["1 month", "3 months", "6 months"]
        },
        {
          label: "API Integration",
          values: ["No", "Yes", "Advanced"]
        }
      ]
    },
    faq: [
      {
        question: "What can be automated?",
        answer: "Almost any repetitive task - data entry, file processing, email responses, report generation, and more."
      },
      {
        question: "Will automation replace my employees?",
        answer: "No, automation handles repetitive tasks so your team can focus on higher-value work."
      }
    ]
  },

  twitter: {
    id: "twitter",
    title: "Twitter Shilling",
    icon: <FaTwitter size={60} color="#1DA1F2" />,
    iconBg: "linear-gradient(135deg, #1DA1F2, #1E90FF)",
    shortDesc: "Professional Twitter promotion services",
    longDesc: "Boost your project's visibility on Twitter with our targeted promotion services. We help crypto projects, startups, and businesses reach their target audience effectively.",
    features: [
      "Crypto promotion",
      "Influencer collaboration",
      "Targeted promotion",
      "Community engagement",
      "Hashtag optimization",
      "Content strategy",
      "Engagement tracking",
      "Growth analytics"
    ],
    process: [
      {
        step: "01",
        title: "Strategy Development",
        desc: "Creating targeted promotion strategy"
      },
      {
        step: "02",
        title: "Content Creation",
        desc: "Engaging tweets and visuals"
      },
      {
        step: "03",
        title: "Campaign Launch",
        desc: "Targeted promotion execution"
      },
      {
        step: "04",
        title: "Engagement",
        desc: "Community interaction and growth"
      },
      {
        step: "05",
        title: "Reporting",
        desc: "Detailed analytics and insights"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Targeted Reach",
        desc: "Connect with your ideal audience"
      },
      {
        icon: <FaRegGem />,
        title: "Crypto Expertise",
        desc: "Specialized in crypto projects"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Proven Results",
        desc: "Track record of success"
      },
      {
        icon: <FaRegClock />,
        title: "Real Engagement",
        desc: "Authentic community growth"
      }
    ],
    pricing: [
      {
        name: "Starter",
        price: "$149",
        period: "per campaign",
        icon: <FaStar />,
        features: [
          "Basic promotion",
          "10 targeted posts",
          "Hashtag strategy",
          "Basic engagement",
          "Weekly report",
          "5 days duration"
        ],
        popular: false,
        hot: false,
        buttonText: "Start Campaign"
      },
      {
        name: "Professional",
        price: "$299",
        period: "per campaign",
        icon: <FaFire />,
        features: [
          "Advanced promotion",
          "25 targeted posts",
          "Influencer outreach",
          "Daily engagement",
          "Real-time analytics",
          "10 days duration",
          "Trending topics",
          "Community growth",
          "Competitor analysis"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Package",
        badge: "🔥 HOT PACKAGE"
      },
      {
        name: "Enterprise",
        price: "$599",
        period: "per campaign",
        icon: <FaCrown />,
        features: [
          "Premium promotion",
          "50+ targeted posts",
          "Multiple influencers",
          "24/7 engagement",
          "Dedicated manager",
          "30 days duration",
          "Custom strategy",
          "Viral campaigns",
          "Full analytics",
          "Brand monitoring"
        ],
        popular: false,
        hot: false,
        buttonText: "Go Premium"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Twitter Strategy?",
      description: "Get a personalized Twitter promotion plan for your specific goals.",
      features: [
        "Custom campaign design",
        "Long-term partnership",
        "Priority support",
        "Exclusive strategies"
      ]
    },
    comparisonChart: {
      labels: ["Starter", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Posts",
          values: [10, 25, "50+"]
        },
        {
          label: "Duration",
          values: ["5 days", "10 days", "30 days"]
        },
        {
          label: "Influencers",
          values: ["No", "Yes", "Multiple"]
        },
        {
          label: "Analytics",
          values: ["Basic", "Real-time", "Advanced"]
        }
      ]
    },
    faq: [
      {
        question: "Do you guarantee followers?",
        answer: "We guarantee authentic engagement, not fake followers. Our focus is on real community growth."
      },
      {
        question: "What results can I expect?",
        answer: "Results vary by niche, but clients typically see 2-5x increase in engagement and followers."
      }
    ]
  },

  discord: {
    id: "discord",
    title: "Discord Promotion",
    icon: <FaDiscord size={60} color="#5865F2" />,
    iconBg: "linear-gradient(135deg, #5865F2, #7289DA)",
    shortDesc: "Targeted Discord marketing services",
    longDesc: "Build and grow your Discord community with our professional promotion and management services. We help crypto projects, gaming communities, and businesses create thriving Discord servers.",
    features: [
      "Community engagement",
      "Targeted promotion",
      "Active moderators",
      "Crypto community outreach",
      "Server setup",
      "Role management",
      "Event organization",
      "Growth strategies"
    ],
    process: [
      {
        step: "01",
        title: "Server Audit",
        desc: "Analyzing current server status"
      },
      {
        step: "02",
        title: "Strategy Planning",
        desc: "Creating growth roadmap"
      },
      {
        step: "03",
        title: "Promotion Launch",
        desc: "Targeted community outreach"
      },
      {
        step: "04",
        title: "Engagement",
        desc: "Active community management"
      },
      {
        step: "05",
        title: "Optimization",
        desc: "Continuous improvement"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Fast Growth",
        desc: "Rapid community expansion"
      },
      {
        icon: <FaRegGem />,
        title: "Quality Members",
        desc: "Targeted, relevant users"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Crypto Focus",
        desc: "Specialized in Web3 communities"
      },
      {
        icon: <FaRegClock />,
        title: "24/7 Management",
        desc: "Round-the-clock moderation"
      }
    ],
    pricing: [
      {
        name: "Basic Growth",
        price: "$199",
        period: "per month",
        icon: <FaStar />,
        features: [
          "Server optimization",
          "Basic promotion",
          "50-100 new members",
          "Basic moderation",
          "Weekly reports",
          "Role setup"
        ],
        popular: false,
        hot: false,
        buttonText: "Start Growing"
      },
      {
        name: "Professional",
        price: "$399",
        period: "per month",
        icon: <FaFire />,
        features: [
          "Advanced promotion",
          "200-500 new members",
          "Active moderation",
          "Event management",
          "Daily engagement",
          "Real-time analytics",
          "Custom bots",
          "Giveaway management",
          "Community events"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Choice",
        badge: "🔥 HOT PACKAGE"
      },
      {
        name: "Enterprise",
        price: "$799",
        period: "per month",
        icon: <FaCrown />,
        features: [
          "Premium promotion",
          "1000+ new members",
          "24/7 moderation",
          "Custom development",
          "Dedicated manager",
          "Advanced analytics",
          "Multi-server support",
          "Partnership outreach",
          "Custom strategy",
          "Priority support"
        ],
        popular: false,
        hot: false,
        buttonText: "Go Premium"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Discord Solution?",
      description: "Get a tailored Discord growth and management package.",
      features: [
        "Custom growth targets",
        "Dedicated team",
        "Custom bot development",
        "Long-term partnership"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Monthly Members",
          values: ["50-100", "200-500", "1000+"]
        },
        {
          label: "Moderation",
          values: ["Basic", "Active", "24/7"]
        },
        {
          label: "Custom Bots",
          values: ["No", "Yes", "Advanced"]
        },
        {
          label: "Support",
          values: ["Standard", "Priority", "Dedicated"]
        }
      ]
    },
    faq: [
      {
        question: "How do you promote Discord servers?",
        answer: "We use targeted outreach, cross-promotions, social media marketing, and community engagement strategies."
      },
      {
        question: "Can you help with server setup?",
        answer: "Yes, we provide complete server setup including channels, roles, bots, and moderation systems."
      }
    ]
  },

  moderator: {
    id: "moderator",
    title: "Hire a Moderator",
    icon: <FaUserShield size={60} color="#EF4444" />,
    iconBg: "linear-gradient(135deg, #EF4444, #F87171)",
    shortDesc: "Professional moderators for your community",
    longDesc: "Keep your Discord, Telegram, or other platforms safe and engaging with our professional moderation services. We provide experienced moderators who maintain order and foster positive community growth.",
    features: [
      "24/7 moderation",
      "Spam control",
      "Community engagement",
      "Security monitoring",
      "Conflict resolution",
      "Rule enforcement",
      "Content moderation",
      "User support"
    ],
    process: [
      {
        step: "01",
        title: "Needs Assessment",
        desc: "Understanding your community needs"
      },
      {
        step: "02",
        title: "Moderator Selection",
        desc: "Matching with experienced moderators"
      },
      {
        step: "03",
        title: "Training",
        desc: "Learning your community guidelines"
      },
      {
        step: "04",
        title: "Active Moderation",
        desc: "Round-the-clock community management"
      },
      {
        step: "05",
        title: "Reporting",
        desc: "Regular updates and insights"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Experienced Team",
        desc: "Years of moderation experience"
      },
      {
        icon: <FaRegGem />,
        title: "Multi-platform",
        desc: "All platforms supported"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Quick Response",
        desc: "Issues handled immediately"
      },
      {
        icon: <FaRegClock />,
        title: "24/7 Coverage",
        desc: "Always watching your community"
      }
    ],
    pricing: [
      {
        name: "Basic Moderation",
        price: "$299",
        period: "per month",
        icon: <FaStar />,
        features: [
          "1 dedicated moderator",
          "8 hours/day coverage",
          "Basic spam control",
          "Rule enforcement",
          "Weekly reports",
          "Standard support"
        ],
        popular: false,
        hot: false,
        buttonText: "Hire Now"
      },
      {
        name: "Professional",
        price: "$549",
        period: "per month",
        icon: <FaFire />,
        features: [
          "2 dedicated moderators",
          "16 hours/day coverage",
          "Advanced spam control",
          "Community engagement",
          "Daily reports",
          "Priority support",
          "Conflict resolution",
          "Event moderation",
          "User onboarding"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Package",
        badge: "🔥 BEST VALUE"
      },
      {
        name: "Enterprise",
        price: "$999",
        period: "per month",
        icon: <FaCrown />,
        features: [
          "4+ moderator team",
          "24/7 full coverage",
          "Enterprise security",
          "Active engagement",
          "Real-time alerts",
          "Dedicated manager",
          "Custom rules",
          "Advanced analytics",
          "Multi-server support",
          "Emergency response"
        ],
        popular: false,
        hot: false,
        buttonText: "Go Enterprise"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Moderation?",
      description: "Get a tailored moderation package for your specific community needs.",
      features: [
        "Custom coverage hours",
        "Language-specific moderators",
        "Specialized expertise",
        "Long-term contracts"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Moderators",
          values: ["1", "2", "4+"]
        },
        {
          label: "Coverage",
          values: ["8 hours", "16 hours", "24/7"]
        },
        {
          label: "Reports",
          values: ["Weekly", "Daily", "Real-time"]
        },
        {
          label: "Support",
          values: ["Standard", "Priority", "Dedicated"]
        }
      ]
    },
    faq: [
      {
        question: "What platforms do you moderate?",
        answer: "We moderate Discord, Telegram, Twitter, Reddit, Facebook groups, and custom platforms."
      },
      {
        question: "How do you handle toxic users?",
        answer: "We follow your guidelines for warnings, mutes, kicks, and bans, always documenting actions."
      }
    ]
  },

  livechat: {
    id: "livechat",
    title: "Live Chat Agent",
    icon: <FaHeadset size={60} color="#14B8A6" />,
    iconBg: "linear-gradient(135deg, #14B8A6, #2DD4BF)",
    shortDesc: "Professional customer support agents",
    longDesc: "Provide exceptional customer support with our professional live chat agents. Available 24/7 to help your customers, answer questions, and resolve issues quickly.",
    features: [
      "24/7 support",
      "Customer management",
      "Fast response",
      "Professional communication",
      "Multi-language support",
      "Ticket system",
      "Sales assistance",
      "Technical support"
    ],
    process: [
      {
        step: "01",
        title: "Training",
        desc: "Learning your products and services"
      },
      {
        step: "02",
        title: "Setup",
        desc: "Integrating with your chat system"
      },
      {
        step: "03",
        title: "Go Live",
        desc: "Starting 24/7 support coverage"
      },
      {
        step: "04",
        title: "Monitoring",
        desc: "Quality assurance and improvement"
      },
      {
        step: "05",
        title: "Reporting",
        desc: "Performance metrics and insights"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Instant Response",
        desc: "Average response under 30 seconds"
      },
      {
        icon: <FaRegGem />,
        title: "Professional",
        desc: "Trained customer service experts"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Multi-lingual",
        desc: "Support in multiple languages"
      },
      {
        icon: <FaRegClock />,
        title: "24/7 Available",
        desc: "Never miss a customer query"
      }
    ],
    pricing: [
      {
        name: "Basic Support",
        price: "$399",
        period: "per month",
        icon: <FaStar />,
        features: [
          "1 dedicated agent",
          "8 hours/day coverage",
          "Basic response scripts",
          "Ticket management",
          "Weekly reports",
          "Standard support"
        ],
        popular: false,
        hot: false,
        buttonText: "Start Support"
      },
      {
        name: "Professional",
        price: "$699",
        period: "per month",
        icon: <FaFire />,
        features: [
          "2 dedicated agents",
          "16 hours/day coverage",
          "Advanced scripts",
          "Sales assistance",
          "Daily reports",
          "Priority response",
          "Multi-language",
          "Technical support",
          "Customer feedback"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Package",
        badge: "⭐ RECOMMENDED"
      },
      {
        name: "Enterprise",
        price: "$1299",
        period: "per month",
        icon: <FaCrown />,
        features: [
          "4+ agent team",
          "24/7 full coverage",
          "Custom scripts",
          "Advanced analytics",
          "Dedicated manager",
          "Real-time monitoring",
          "Multi-channel",
          "CRM integration",
          "Training included",
          "SLA guarantee"
        ],
        popular: false,
        hot: false,
        buttonText: "Go Enterprise"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Support Solution?",
      description: "Get a tailored live chat support package for your business.",
      features: [
        "Custom coverage hours",
        "Industry-specific training",
        "Multi-channel support",
        "Dedicated team"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Agents",
          values: ["1", "2", "4+"]
        },
        {
          label: "Coverage",
          values: ["8 hours", "16 hours", "24/7"]
        },
        {
          label: "Languages",
          values: ["1", "2-3", "Multiple"]
        },
        {
          label: "Response Time",
          values: ["<60s", "<30s", "<15s"]
        }
      ]
    },
    faq: [
      {
        question: "What platforms do you support?",
        answer: "We work with all major chat platforms including LiveChat, Intercom, Zendesk, Slack, and custom solutions."
      },
      {
        question: "Can agents handle sales?",
        answer: "Yes, our agents are trained in both support and sales to help convert customers."
      }
    ]
  },

  graphics: {
    id: "graphics",
    title: "Graphics Design",
    icon: <FaPaintBrush size={60} color="#8B5CF6" />,
    iconBg: "linear-gradient(135deg, #8B5CF6, #A78BFA)",
    shortDesc: "Creative graphic design services",
    longDesc: "Transform your brand with stunning visuals. Our creative team delivers eye-catching designs that capture attention and communicate your message effectively across all media.",
    features: [
      "Brand identity",
      "Social media design",
      "Logo design",
      "UI design",
      "Marketing materials",
      "Print design",
      "Infographics",
      "Packaging design"
    ],
    process: [
      {
        step: "01",
        title: "Brief",
        desc: "Understanding your vision and needs"
      },
      {
        step: "02",
        title: "Research",
        desc: "Market and competitor analysis"
      },
      {
        step: "03",
        title: "Concepts",
        desc: "Creating initial design concepts"
      },
      {
        step: "04",
        title: "Refinement",
        desc: "Perfecting based on feedback"
      },
      {
        step: "05",
        title: "Delivery",
        desc: "Final files in all formats"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Creative Team",
        desc: "Award-winning designers"
      },
      {
        icon: <FaRegGem />,
        title: "Quick Turnaround",
        desc: "Fast delivery without compromise"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Unlimited Revisions",
        desc: "Until you're 100% satisfied"
      },
      {
        icon: <FaRegClock />,
        title: "All Formats",
        desc: "Print, web, and social ready"
      }
    ],
    pricing: [
      {
        name: "Basic Design",
        price: "$149",
        period: "per project",
        icon: <FaStar />,
        features: [
          "Logo design",
          "3 initial concepts",
          "2 rounds of revisions",
          "Social media kit",
          "Business card design",
          "Source files included"
        ],
        popular: false,
        hot: false,
        buttonText: "Start Design"
      },
      {
        name: "Professional",
        price: "$349",
        period: "per project",
        icon: <FaFire />,
        features: [
          "Complete branding",
          "5 initial concepts",
          "Unlimited revisions",
          "Full social media pack",
          "Stationery design",
          "Brand guidelines",
          "Marketing materials",
          "Print-ready files",
          "Web assets"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Package",
        badge: "🔥 BEST SELLER"
      },
      {
        name: "Enterprise",
        price: "$699",
        period: "per project",
        icon: <FaCrown />,
        features: [
          "Full brand identity",
          "10+ initial concepts",
          "Unlimited everything",
          "Complete brand system",
          "Custom illustrations",
          "Packaging design",
          "Website UI kit",
          "Animation ready",
          "Dedicated designer",
          "Priority support"
        ],
        popular: false,
        hot: false,
        buttonText: "Go Premium"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Design Work?",
      description: "Get a personalized design package for your specific project needs.",
      features: [
        "Custom project scope",
        "Dedicated design team",
        "Long-term partnership",
        "Priority delivery"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Concepts",
          values: [3, 5, "10+"]
        },
        {
          label: "Revisions",
          values: [2, "Unlimited", "Unlimited"]
        },
        {
          label: "Brand Guidelines",
          values: ["No", "Yes", "Complete"]
        },
        {
          label: "Custom Illustrations",
          values: ["No", "Basic", "Yes"]
        }
      ]
    },
    faq: [
      {
        question: "How long does design take?",
        answer: "Logo design takes 3-5 days, complete branding 1-2 weeks, depending on complexity."
      },
      {
        question: "What file formats do you provide?",
        answer: "We provide AI, PSD, PDF, PNG, JPG, SVG, and all other formats you need."
      }
    ]
  },

  video: {
    id: "video",
    title: "Motion & Video Production",
    icon: <FaVideo size={60} color="#F43F5E" />,
    iconBg: "linear-gradient(135deg, #F43F5E, #FB7185)",
    shortDesc: "Professional video editing & motion graphics",
    longDesc: "Bring your ideas to life with professional video production. From editing to motion graphics and animations, we create compelling video content that engages your audience.",
    features: [
      "Video editing",
      "Motion graphics",
      "Promotional videos",
      "YouTube content editing",
      "2D/3D animation",
      "Visual effects",
      "Color grading",
      "Sound design"
    ],
    process: [
      {
        step: "01",
        title: "Script & Storyboard",
        desc: "Planning your video narrative"
      },
      {
        step: "02",
        title: "Production",
        desc: "Filming or asset creation"
      },
      {
        step: "03",
        title: "Editing",
        desc: "Professional video editing"
      },
      {
        step: "04",
        title: "Motion Graphics",
        desc: "Adding animations and effects"
      },
      {
        step: "05",
        title: "Final Delivery",
        desc: "Optimized for all platforms"
      }
    ],
    whyChooseUs: [
      {
        icon: <FaRocket />,
        title: "Cinematic Quality",
        desc: "Hollywood-level production"
      },
      {
        icon: <FaRegGem />,
        title: "Fast Delivery",
        desc: "Quick turnaround times"
      },
      {
        icon: <FaRegLightbulb />,
        title: "Creative Team",
        desc: "Experienced video professionals"
      },
      {
        icon: <FaRegClock />,
        title: "All Formats",
        desc: "Optimized for any platform"
      }
    ],
    pricing: [
      {
        name: "Basic Edit",
        price: "$199",
        period: "per video",
        icon: <FaStar />,
        features: [
          "Basic video editing",
          "Simple transitions",
          "Color correction",
          "Background music",
          "1 round of revisions",
          "Social media format"
        ],
        popular: false,
        hot: false,
        buttonText: "Start Project"
      },
      {
        name: "Professional",
        price: "$499",
        period: "per video",
        icon: <FaFire />,
        features: [
          "Advanced editing",
          "Motion graphics",
          "Custom animations",
          "Sound design",
          "3 rounds of revisions",
          "Multiple formats",
          "Title animations",
          "Visual effects",
          "Color grading"
        ],
        popular: true,
        hot: true,
        buttonText: "Popular Package",
        badge: "⭐ MOST POPULAR"
      },
      {
        name: "Enterprise",
        price: "$999",
        period: "per video",
        icon: <FaCrown />,
        features: [
          "Full production",
          "Custom 3D animations",
          "Advanced VFX",
          "Professional voiceover",
          "Unlimited revisions",
          "All formats & sizes",
          "Dedicated team",
          "Script writing",
          "Storyboarding",
          "Priority delivery"
        ],
        popular: false,
        hot: false,
        buttonText: "Go Premium"
      }
    ],
    customDeal: {
      enabled: true,
      title: "Need Custom Video Production?",
      description: "Get a personalized video production package for your specific needs.",
      features: [
        "Custom video series",
        "Long-term partnership",
        "Dedicated production team",
        "Priority scheduling"
      ]
    },
    comparisonChart: {
      labels: ["Basic", "Professional", "Enterprise"],
      datasets: [
        {
          label: "Editing Level",
          values: ["Basic", "Advanced", "Full Production"]
        },
        {
          label: "Motion Graphics",
          values: ["No", "Yes", "Advanced 3D"]
        },
        {
          label: "Revisions",
          values: [1, 3, "Unlimited"]
        },
        {
          label: "Voiceover",
          values: ["No", "Basic", "Professional"]
        }
      ]
    },
    faq: [
      {
        question: "What video formats do you deliver?",
        answer: "We deliver in all formats: MP4, MOV, AVI, plus optimized versions for YouTube, Instagram, TikTok, and more."
      },
      {
        question: "Can you work with my raw footage?",
        answer: "Absolutely! Send us your footage and we'll transform it into a professional video."
      }
    ]
  }
};